import { render, staticRenderFns } from "./LoyaltyTierForm.vue?vue&type=template&id=312196f4&"
import script from "./LoyaltyTierForm.vue?vue&type=script&lang=js&"
export * from "./LoyaltyTierForm.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyTierForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports